import React from 'react'
import PropTypes from 'prop-types'
import Tweet from '@/component/Primitive/Tweet'

const TweetWidget = ({ tweetId, tweetContent }) => (
  <Tweet tweetId={tweetId} tweetText={tweetContent} />
)

TweetWidget.propTypes = {
  tweetId: PropTypes.string,
  tweetContent: PropTypes.string
}

export default TweetWidget
